let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3OPjU")).then(() => parcelRequire('8vLL9'));